<template>
    <div class="bottom_navbar">
            <el-row :gutter="20" class="c_height_260">
                <el-col :span="4" class="c_height_260">
                    <div class="c_div_logo">
                        <div class="introduction_pic">
                            <img src="@/assets/logo.jpg" alt="本地图片">
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" class="c_height_260">
                    <div class="c_div_1">
                        <div class="c_div_title">九任智造</div>
                        <div class="c_div_body">
                            <div>名称：湖南九任智造科技有限公司</div>
                            <div>地址：湖南省资兴市经开区唐洞街道龙头社区智能装备智造产业园C1栋</div>
                            <div>电话：151 1236 2842</div>
                            <div>邮箱：devin@ixren.com</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" class="c_height_260">
                    <div class="c_div_1">
                        <span class="c_div_title">产品中心</span>
                        <div class="c_div_body">
                            <div>服务器</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" class="c_height_260">
                    <div class="c_div_1">
                        <span class="c_div_title">关于我们</span>
                        <div class="c_div_body">
                            <div><a href="/introduction" target="_self">公司介绍</a></div>
                            <div><a href="/recruit" target="_self">招贤纳士</a></div>
                            <div><a href="/contact" target="_self">联系我们</a></div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" class="c_height_260">
                    <div class="c_div_1">
                        <span class="c_div_title">关注我们</span>
                        <div>
                            <div class="introduction_pic">
                                <img src="@/assets/qr.jpg" alt="本地图片">
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        <div class="c_div_end">
                版权所有 湖南九任智造科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">湘ICP备2025112062号</a>
        </div>
    </div>
</template>

<style scoped lang="scss">
.bottom_navbar {
    position: relative;
    bottom: 0;
    background-color:rgb(32,38,42);
    padding:10px 60px;

}

.introduction_pic {
    background-position: center center;
    background-size: cover;
    max-width: 150px;
    margin-top: 10px;
}

img {
    border: 0;
    vertical-align: bottom;
    width: 100%;
    height: 100%;
}

a {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 60;
    cursor: pointer;
    text-decoration: none;
    color: rgba(255, 255, 255, 0.85);
}

a:hover,
a:active {
    color: #4e89ff;
}

.c_height_260 {
    height:260px;
}

.c_div_1 {
    padding:14px;
    line-height: 39px;
}

.c_div_logo {
    margin-top: 60px;
    margin-right: 50px;
}

.c_div_title {
    font-size:18px;
    color:white;
}

.c_div_body {
    font-size:14px;
    color:white;
    line-height:35px;
}

.c_div_end {
    font-size:16px;
    text-align:center;
    color:white;
}
</style>

<script setup>
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
</script>